export default __webpack_public_path__ + "static/media/export-csv-icon.9f11b4ab.svg";